// extracted by mini-css-extract-plugin
module.exports = {"spacer":"Spacer_spacer__3yqZR"};